module.exports = __webpack_public_path__ + "static/virego_main_7-83281229df0c3e0db068dc133d988a9d.png";